export default __html => ({ __html })
